var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShieldCheck } from '@fortawesome/pro-solid-svg-icons/faShieldCheck';
import { faSignOut } from '@fortawesome/pro-solid-svg-icons/faSignOut';
import { faUserEdit } from '@fortawesome/pro-solid-svg-icons/faUserEdit';
import { IconContainer, MenuItemContainer, MenuItemTitle, ProfileContainer, } from './styles';
var Profile = function (_a) {
    var onClose = _a.onClose, onLogout = _a.onLogout, onHide = _a.onHide;
    var navigate = useNavigate();
    Profile.handleClickOutside = function () {
        onClose();
    };
    var handleNavigate = function (path) {
        if (path === void 0) { path = '/'; }
        onHide();
        navigate(path);
    };
    return (_jsxs(ProfileContainer, { children: [_jsxs(MenuItemContainer, __assign({ firstItem: true, onClick: function () { return handleNavigate('/preference'); }, navSubBar: true }, { children: [_jsx(IconContainer, { children: _jsx(FontAwesomeIcon, { fixedWidth: true, color: "#000000", size: "1x", icon: faUserEdit }) }), _jsx(MenuItemTitle, __assign({ navSubBarText: true }, { children: "Profile" }))] })), _jsxs(MenuItemContainer, __assign({ onClick: function () { return handleNavigate('/dataprivacy'); }, navSubBar: true }, { children: [_jsx(IconContainer, { children: _jsx(FontAwesomeIcon, { fixedWidth: true, color: "#000000", size: "1x", icon: faShieldCheck }) }), _jsx(MenuItemTitle, __assign({ navSubBarText: true }, { children: "Data & Privacy" }))] })), _jsxs(MenuItemContainer, __assign({ lastItem: true, onClick: onLogout, navSubBar: true }, { children: [_jsx(IconContainer, { children: _jsx(FontAwesomeIcon, { fixedWidth: true, color: "#000000", size: "1x", icon: faSignOut }) }), _jsx(MenuItemTitle, __assign({ navSubBarText: true }, { children: "Log out" }))] }))] }));
};
Profile.handleClickOutside = function () { return null; };
export default Profile;
